/** Resolve a CMS `link` field group to an href (pages-only references). */
export const resolveLinkHref = (link?: {
  type?: 'reference' | 'custom' | null
  reference?: { value?: unknown } | null
  url?: string | null
} | null): string => {
  if (
    link?.type === 'reference' &&
    link?.reference &&
    typeof link.reference.value === 'object' &&
    link.reference.value !== null &&
    'slug' in link.reference.value &&
    (link.reference.value as { slug?: string }).slug
  ) {
    return `/${(link.reference.value as { slug?: string }).slug}`
  }
  return link?.url ?? ''
}
